import Link from "../../utils/Link";
import * as React from "react";
import useTranslations from "../../../hooks/useTranslations";
import UserAvatar from "../../utils/avatars/UserAvatar";
import Activity from "../ActivityPlate";
import { Text } from "@chakra-ui/react";
import {
  ActivityFragment,
  CampaignSummaryFragment,
  UserMinimalFragment,
} from "../../../graphql/generated/definitions";

type UserDocumentDeletedActivity = ActivityFragment & {
  recipient: CampaignSummaryFragment;
  trackable: UserMinimalFragment;
};

export function isUserDocumentDeletedActivity(
  q: ActivityFragment
): q is UserDocumentDeletedActivity {
  return q.key === "user.document_deleted";
}

interface UserDocumentDeletedActivityProps {
  activity: UserDocumentDeletedActivity;
}

export const UserDocumentDeletedActivity: React.FC<UserDocumentDeletedActivityProps> =
  ({ activity }) => {
    const t = useTranslations();

    return (
      <Activity
        activity={activity}
        id="userDocumentDeletedActivity"
        visual={
          <UserAvatar
            src={activity.trackable.avatar}
            alt={`${activity.trackable.name} avatar`}
            size={10}
          />
        }
      >
        <Text fontSize="sm">
          {t("activity.labels.userDocumentDeleted", {
            user: (
              <Link to={`/users/${activity.trackable.slug}`}>
                {activity.trackable.name}
              </Link>
            ),
          })}
        </Text>
      </Activity>
    );
  };
